import React, { useState } from 'react';
import Tab from 'reusable/tab';
import VehicleInspectionManagement from './VehicleInspectionManagement';
import AllVehicleManagement from './AllVehicleManagement';
import { useTranslation } from 'react-i18next';


const VehicleManagement: React.FC = () => {
  const { t, i18n } = useTranslation('vehicle');
  const tabsData = [
    { label: `${t('tab.all-vehicle')}`, value: 'allvehicle' },
    { label: `${t('tab.inspection-record')}`, value: 'inspectionrecord' },
  ];
  const [activeTab, setActiveTab] = useState<string>(tabsData[0].value);

  const handleTabClick = (value: string) => {
    setActiveTab(value);
  };
  return (
    <section className="bg-white rounded-md p-4">
      {/* Tab Section */}
      <Tab tabs={tabsData} onTabClick={handleTabClick} />
      {/* Table */}
      {activeTab === 'allvehicle' && <AllVehicleManagement />}
      {activeTab === 'inspectionrecord' && <VehicleInspectionManagement />}
      {/* Pagination */}
    </section>
  );
};
export default VehicleManagement;